import dayjs from 'dayjs';
// 时间戳转 ISO 8601 格式
const timestampToISO = (timestamp) => {
  return new Date(timestamp).toISOString();
};

// ISO 8601 格式转时间戳
const isoToTimestamp = (isoString) => {
  return new Date(isoString).getTime();
};

const formattedDate = (timestamp) => {
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
};

export { timestampToISO, isoToTimestamp, formattedDate };
